import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import {
  hasInvestorPricingReturn,
  shouldSkipInvestorScrollToTop,
  watchInvestorPricingReturn,
} from '../utils/investorPricingReturnScroll';

/**
 * Ensures every route navigation starts at the top of the page.
 * The extra frame beats the browser putting the dashboard's scroll
 * position onto the next page.
 *
 * Exception: back from /investors/pricing to /investors restores the
 * CTA the visitor clicked instead of jumping to the top.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    if (shouldSkipInvestorScrollToTop(pathname)) {
      if (hasInvestorPricingReturn()) {
        return watchInvestorPricingReturn();
      }
      return;
    }

    const scrollTop = () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    scrollTop();
    const frame = requestAnimationFrame(scrollTop);
    return () => cancelAnimationFrame(frame);
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
